import { useForm } from '@inertiajs/react'
import type { ReactNode } from 'react'
import { Building2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import AppLayout from '@/layouts/AppLayout'
import AccountLayout from '@/layouts/AccountLayout'

interface Props {
  organization: {
    name: string
    slug: string
    website: string | null
  } | null
}

export default function AccountOrganization({ organization }: Props) {
  const { data, setData, patch, processing } = useForm({
    organization: {
      website: organization?.website ?? '',
    },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    patch('/account/organization')
  }

  if (!organization) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <Building2 className="h-12 w-12 text-muted-foreground mb-4" />
        <h2 className="text-xl font-semibold">No Company</h2>
        <p className="text-sm text-muted-foreground mt-1">
          You are not part of a company yet.
        </p>
      </div>
    )
  }

  return (
    <div className="max-w-sm">
      <h1 className="text-2xl font-semibold mb-6">Company Settings</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="name">Company Name</Label>
          <Input id="name" value={organization.name} disabled />
        </div>
        <div className="space-y-2">
          <Label htmlFor="website">Company Website</Label>
          <Input
            id="website"
            type="url"
            value={data.organization.website}
            onChange={(e) => setData('organization', { ...data.organization, website: e.target.value })}
            placeholder="https://acmehealth.com"
          />
        </div>

        <Button type="submit" disabled={processing}>
          {processing ? 'Saving...' : 'Save'}
        </Button>
      </form>
    </div>
  )
}

AccountOrganization.layout = (page: ReactNode) => (
  <AppLayout>
    <AccountLayout>{page}</AccountLayout>
  </AppLayout>
)
